import React from 'react';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { MobileDrawerProps } from '../../types/navigation.types';

export const MobileDrawer: React.FC<MobileDrawerProps> = ({ items, open, onClose }) => {
    const drawerContent = (
        <Box onClick={onClose} sx={{ textAlign: 'center' }}>
            <List>
                {items.map((item) => (
                    <ListItem
                        key={item.label}
                        component={RouterLink}
                        to={item.path}
                        sx={{ textAlign: 'center' }}
                    >
                        <ListItemText primary={item.label} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <Drawer
            variant="temporary"
            anchor="left"
            open={open}
            onClose={onClose}
            ModalProps={{
                keepMounted: true,
            }}
        >
            {drawerContent}
        </Drawer>
    );
}; 